import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';

import { CurrencyCasePipeModule } from '~/core/helpers/currency-case-pipe/currency-case.module';
import { MenuTopBarBasicMobilePlus2Component } from './menu-top-bar-basic-mobile-plus2.component';

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    RouterModule,
    MatSidenavModule,
    MatIconModule,
    MatTabsModule,
    TranslateModule,
    CurrencyCasePipeModule,
    MatButtonModule,
    MenuTopBarBasicMobilePlus2Component
  ],
  exports: [MenuTopBarBasicMobilePlus2Component],
})
export class MenuTopBarBasicMobilePlus2Module { }
